/**
 * Шаблон настроек для сайтов
 *
 * @param  { String } useDeskId - id usedesk
 * @param  { String } themeColor - цветовая тема для браузера
 * @param  { String } yandexVerification - id яндекса
 * @param  { String } facebookVerification - id facebook pixel
 * @param  { Number } ymId - id яндекс метрики
 * @param  { Object } myTarget - Настройки MyTarget
 * @param  { String } name - название бренда
 * @param  { String } apiName - официальное название бренда
 * @param  { String } domain - домен
 * @param  { Number } idGTM - id google tag manager
 * @param  { String } font - font family
 * @return { Object }
 */
function createTemplate({
    useDeskId,
    themeColor,
    yandexVerification,
    facebookVerification = "",
    ymId,
    myTarget = {},
    name,
    apiName,
    domain,
    idGTM,
    font,
}) {
    const apiUrlName = apiName ? apiName : name;

    return {
        useDeskId,
        themeColor,
        yandexVerification,
        facebookVerification,
        ymId,
        myTarget,
        name,
        apiName: apiUrlName,
        domain,
        urlApi: createApi(apiUrlName, domain),
        idGTM,
        font,
    };
}

/**
 * Формирование адреса api
 *
 * @param  { String } name - название бренда
 * @param  { String } domain - домен
 * @return { Object }
 */
function createApi(name, domain) {
    const isTestApi = process.env.VUE_APP_API;
    const prefix = "api.";

    if (name === "khalatentse") {
        name = "xn--80aapa1ao7aup";
        domain = "xn--p1ai";
    }

    return process.env.NODE_ENV === "development" || isTestApi
        ? `https://${prefix}${name}.${domain}`
        : `https://${prefix}${name}.${domain}`;
}

module.exports = { createTemplate };
